import NotificationsStep from './NotificationsStep';

export default NotificationsStep;
